module.exports = __webpack_public_path__ + "static/img/4.f07a56b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20251009/4.jpg
// module id = nSxa
// module chunks = 7